import { $ } from '../common/dom.ts';

/**
 * Menu du jeu : un bouton en haut à droite ouvre ou ferme un grand panneau (équipe, Pokédex, carte…).
 * Chaque entrée garde son propre comportement ; choisir une entrée referme le menu, sauf `data-keep-open`.
 */
export class HudMenu {
  private readonly toggle = $<HTMLButtonElement>('#btn-menu');
  private readonly panel = $('#hud-menu');

  constructor() {
    this.toggle.addEventListener('click', () => (this.isOpen ? this.close() : this.open()));
    this.panel.addEventListener('click', (event) => {
      const item = (event.target as Element).closest('button');
      if (item && !item.hasAttribute('data-keep-open')) this.close();
    });
    // Un appui ailleurs (le monde, la croix…) referme le menu.
    document.addEventListener('pointerdown', (event) => {
      if (this.isOpen && !(event.target as Element).closest('#hud-menu, #btn-menu')) this.close();
    });
    window.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isOpen) this.close();
    });
  }

  get isOpen(): boolean {
    return !this.panel.hidden;
  }

  open(): void {
    this.panel.hidden = false;
    this.toggle.setAttribute('aria-expanded', 'true');
    this.toggle.classList.add('active');
  }

  close(): void {
    this.panel.hidden = true;
    this.toggle.setAttribute('aria-expanded', 'false');
    this.toggle.classList.remove('active');
  }
}
